import { render, staticRenderFns } from "./statuses-statistics-details.vue?vue&type=template&id=2d387f18&scoped=true&"
import script from "./statuses-statistics-details.vue?vue&type=script&lang=js&"
export * from "./statuses-statistics-details.vue?vue&type=script&lang=js&"
import style0 from "./statuses-statistics-details.vue?vue&type=style&index=0&id=2d387f18&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d387f18",
  null
  
)

export default component.exports